class WishlistError extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'WishlistError'
    }
}

export {WishlistError}
